// A single global slot holding the currently-mounted page's "do I have
// unsaved changes right now" check, plus the message to show for it.
// With a classic BrowserRouter (not a data router), only one route is ever
// mounted at a time, so a single mutable ref is enough here - no Context
// provider/consumer wiring needed. GuardedRouterLink (used by Navigation)
// reads this on every in-app link click; a page opts in by setting it on
// mount and clearing it on unmount.
export const unsavedChangesGuardRef = {
	current: null, // () => boolean, or null if the current page has nothing to guard
};

export const defaultUnsavedChangesMessage =
	"You have unsaved changes. Are you sure you want to leave this page?";
